import { Action } from '@ngrx/store';

import { InitiateConfig, SearchedValue } from './service-locator.models';

export enum ServiceLocatorActionTypes {
  SERVICE_SEARCH_INIT = '[Service Locator] Search Shops Initialize',

  SERVICE_SEARCH = '[Service Locator] Search Shops',
  SERVICE_SEARCH_SUCCESS = '[Service Locator] Search Shops Success',
  SERVICE_SEARCH_FAIL = '[Service Locator] Search Shops Fail',
  SET_LAST_SUCCESSFUL_SEARCHED_VALUE = '[Service Locator] Set Last Successful Searched Value',
  SERVICE_SEARCH_BY_CHANGED = '[Service Locator] Search by changed'
}

export class ServiceSearchInitAction implements Action {
  readonly type = ServiceLocatorActionTypes.SERVICE_SEARCH_INIT;
  constructor(public payload: InitiateConfig) {}
}

export class ServiceSearchAction implements Action {
  readonly type = ServiceLocatorActionTypes.SERVICE_SEARCH;
  constructor(public payload: SearchedValue) {}
}

export class ServiceSearchSuccessAction implements Action {
  readonly type = ServiceLocatorActionTypes.SERVICE_SEARCH_SUCCESS;
  constructor(public payload: any) {}
}

export class ServiceSearchFailAction implements Action {
  readonly type = ServiceLocatorActionTypes.SERVICE_SEARCH_FAIL;
  constructor(public payload: any) {}
}

export class SetLastSuccessfulSearchedValueAction implements Action {
  readonly type = ServiceLocatorActionTypes.SET_LAST_SUCCESSFUL_SEARCHED_VALUE;
  constructor(public payload: any) {}
}

export class ServiceSearchByChanged implements Action {
  readonly type = ServiceLocatorActionTypes.SERVICE_SEARCH_BY_CHANGED;
}

export type ServiceLocatorActions =
  | ServiceSearchInitAction
  | ServiceSearchAction
  | ServiceSearchSuccessAction
  | ServiceSearchFailAction
  | SetLastSuccessfulSearchedValueAction
  | ServiceSearchByChanged;
